// Режим маршрутизации: client (по умолчанию) - свой роутер по тайлам графа, на
// сервер не обращается; server - прежний POST /routing/path (оставлен на всякий
// случай); both - оба, ответ сервера и замеры/сверка в консоль. Приоритет:
// ?routing= в URL, затем localStorage["ecoway.routing"], затем client.
export type RoutingMode = "server" | "client" | "both";
const KEY = "ecoway.routing";
const valid = (v: string | null): v is RoutingMode => v === "server" || v === "client" || v === "both";

export function getRoutingMode(): RoutingMode {
  try {
    const q = new URLSearchParams(window.location.search).get("routing");
    if (valid(q)) return q;
  } catch {
    // нет window/URL - остаёмся на значении по умолчанию
  }
  try {
    const s = window.localStorage.getItem(KEY);
    if (valid(s)) return s;
  } catch {
    // localStorage недоступен
  }
  return "client";
}
